import * as React from 'react';
import { useAppSelector } from 'src/store/hooks';

const SQReportView: React.FunctionComponent<any> = () => {
  const showCMPArr: any = useAppSelector(state => state.sqReport.showCMPArr);
  return (
    <>
      {showCMPArr.map((ele: any) => (
        <>{ele.curruntlyActive ? <ele.cmp item={ele} /> : null}</>
      ))}
    </>
  );
};
export default SQReportView;
